import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import { IPageResponse } from '../../../models/Pages'
import { locale } from '../../../state/locale/atoms/locale'
import PageWrapper from '../../_layout/PageWrapper'
import { Loading } from '../../reusable/Loading'
import { Page } from '../../templates/Page'

export const PolicyScreen = () => {
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IPageResponse>(URI.getPageUri('privacy_policy', lang))

  return (
    <PageWrapper>
      {isValidating && <Loading />}
      {!!data?.data.length && <Page data={data.data[0]} />}
    </PageWrapper>
  )
}
